import React from 'react'
import { NEWS_KEYWORDS, buildHighlightPattern } from '../../constants/newsKeywords'

type KeywordTextProps = {
  text: string
  extraKeywords?: string[]
  className?: string
}

export default function KeywordText({ text, extraKeywords = [], className }: KeywordTextProps) {
  const pattern = React.useMemo(() => {
    const merged = [...NEWS_KEYWORDS]
    for (const kw of extraKeywords) {
      const k = kw.trim()
      if (k) merged.push(k)
    }
    return buildHighlightPattern(merged)
  }, [extraKeywords])

  if (!text) return null
  if (!pattern) {
    return <span className={className}>{text}</span>
  }

  const parts = text.split(pattern)
  const matches = text.match(pattern) || []

  const nodes: React.ReactNode[] = []
  parts.forEach((part, i) => {
    if (part) nodes.push(<React.Fragment key={`t-${i}`}>{part}</React.Fragment>)
    if (matches[i]) {
      nodes.push(
        <mark key={`m-${i}`} className="news-kw-highlight">
          {matches[i]}
        </mark>,
      )
    }
  })

  return <span className={className}>{nodes}</span>
}
